import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToastService } from "../core/toast.service";

@Component({
  selector: "app-toast-container",
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-stack">
      <div class="toast" *ngFor="let t of toast.toasts()" [class]="'toast-' + t.type">
        <svg *ngIf="t.type === 'success'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>
        <svg *ngIf="t.type === 'error'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        <svg *ngIf="t.type === 'info'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        <span>{{ t.message }}</span>
        <button class="toast-close" (click)="toast.dismiss(t.id)" aria-label="Dismiss">✕</button>
      </div>
    </div>
  `,
  styles: [
    `
      .toast-stack {
        position: fixed;
        top: 16px;
        right: 16px;
        z-index: 2000;
        display: flex;
        flex-direction: column;
        gap: 8px;
        max-width: min(360px, calc(100vw - 32px));
      }
      .toast {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 12px 14px;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.4;
        box-shadow: 0 8px 24px rgba(2, 6, 23, 0.18);
        border: 1px solid transparent;
        animation: toast-in 0.18s ease-out;
      }
      .toast svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        margin-top: 1px;
      }
      .toast span {
        flex: 1;
        min-width: 0;
        word-break: break-word;
      }
      .toast-close {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 12px;
        line-height: 1;
        padding: 2px;
        opacity: 0.6;
        color: inherit;
      }
      .toast-close:hover {
        opacity: 1;
      }
      .toast-success {
        background: var(--green-soft, #e7f7ee);
        color: var(--green, #18a957);
        border-color: var(--green, #18a957);
      }
      .toast-error {
        background: var(--red-soft, #fdeaea);
        color: var(--red, #e03b3b);
        border-color: var(--red, #e03b3b);
      }
      .toast-info {
        background: #eff6ff;
        color: #1d4ed8;
        border-color: #1d4ed8;
      }
      @keyframes toast-in {
        from {
          opacity: 0;
          transform: translateY(-6px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
  ],
})
export class ToastContainerComponent {
  toast = inject(ToastService);
}
